export const translated = {
  navOne: {
    en: "currency",
    fr: "devise",
    kr: "통화"
  },
  navTwo: {
    en: "Log in",
    fr: "se connecter",
    kr: "로그인"
  },
  navThree: {
    en: "Log Out",
    fr: "Se déconnecter",
    kr: "로그아웃"
  },
  header: {
    en: "SUPER MODERN BANK",
    fr: "BANQUE SUPER MODERNE",
    kr: "슈퍼 모던한 은행"
  },
  subheader: {
    en: "We Are Without a Doubt, the Bankiest Bank to Ever Bank",
    fr: "Nous Sommes Sans Aucun Doute, la Banque la Plus Bancale à Jamais",
    kr: "의심의 여지없이 우리는 역대 은행 중 최고의 은행이다"
  },
  button: {
    en: "Learn More",
    fr: "Plus D’informations",
    kr: "더 알아보기"
  },
  loginHeader: {
    en: "Login",
    fr: "S'identifier",
    kr: "로그인"
  },
  loginMsg: {
    en: "Please enter your login details in the form below (Try Moscow/Russia)",
    fr:
      "Veuillez saisir vos informations de connexion dans le formulaire ci-dessous",
    kr: "로그인 세부 정보를 아래 양식에 입력하십시오"
  },
  loginCancel: {
    en: "Cancel",
    fr: "Annuler",
    kr: "취소"
  },
  loginSubmit: {
    en: "Submit",
    fr: "Soumettre",
    kr: "제출"
  },
  loginUser: {
    en: "Username",
    fr: "Nom d'utilisateur",
    kr: "아이디"
  },
  loginPassword: {
    en: "Password",
    fr: "Mot de passe",
    kr: "비밀번호"
  }
};
